import { Box, modeColor, Stack, Z_INDEX } from '@talos/kyoko';
import styled, { css } from 'styled-components';

const MODAL_SHEET_BORDER_RADIUS = 38;

export const DragHandle = styled(Box)`
  position: absolute;
  top: 8px;
  left: 50%;
  width: 36px;
  transform: translateX(-50%);
  height: 4px;
  border-radius: 2px;
  background: ${({ theme }) => theme.colors.gray['050']};
  cursor: grab;
  z-index: 10;

  &:active {
    cursor: grabbing;
  }
`;

export const SheetModal = styled(Stack)<{ isOpen: boolean; dragOffset: number }>`
  position: fixed;
  top: calc(env(safe-area-inset-top) + 22px);
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${Z_INDEX.modal};
  // padding-bottom: calc(env(safe-area-inset-bottom) * 2);
  background: ${({ theme }) => theme.backgroundContent};
  box-shadow:
    0 0 24px ${({ theme }) => modeColor(theme, theme.colors.black.mute, theme.colors.black.dim)},
    0 0 12px ${({ theme }) => modeColor(theme, theme.colors.black.mute, theme.colors.black.dim)};
  border-radius: ${MODAL_SHEET_BORDER_RADIUS}px ${MODAL_SHEET_BORDER_RADIUS}px 0 0;
  overflow: hidden;
  padding-top: 20px;
  touch-action: pan-y;

  transform: translateY(100%);
  ${({ isOpen, dragOffset }) =>
    isOpen &&
    css`
      transform: translateY(${dragOffset}px);
    `}
  transition: ${({ dragOffset }) => (dragOffset === 0 ? 'transform 0.2s ease-in-out' : 'none')};
`;

export const MobileModalBackdropWrapper = styled(Box)<{ isOpen: boolean }>`
  flex: 1;
  opacity: ${({ isOpen }) => (isOpen ? 0.8 : 1)};
  transform: scale(1) translateY(0);
  transform-origin: top center;
  transition:
    transform 0.2s ease-in-out,
    border-radius 0.2s ease-in-out,
    top 0.2s ease-in-out;
  position: fixed;
  inset: 0;

  ${({ isOpen }) =>
    isOpen &&
    css`
      border-radius: ${MODAL_SHEET_BORDER_RADIUS}px;
      overflow: hidden;
      --scale: calc((100vw - 24px) / 100vw);
      transform: scale(var(--scale)) translateY(12px);
      pointer-events: none;
      top: env(safe-area-inset-top);
    `}
`;
